import { render, staticRenderFns } from "./CreateCardModal.vue?vue&type=template&id=54a03db9&"
import script from "./CreateCardModal.vue?vue&type=script&lang=js&"
export * from "./CreateCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports